import { render, staticRenderFns } from "./vip-customer-pending.vue?vue&type=template&id=a087f058&scoped=true"
import script from "./vip-customer-pending.vue?vue&type=script&lang=js"
export * from "./vip-customer-pending.vue?vue&type=script&lang=js"
import style0 from "./vip-customer-pending.vue?vue&type=style&index=0&id=a087f058&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a087f058",
  null
  
)

export default component.exports